import React from 'react';
import { merge } from './helpers.js';

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;
  if (!css || typeof document === 'undefined') { return; }
  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';
  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".styles-module_Tabs__2nklQ{align-items:center;color:var(--brown-gray);fill:var(--brown-gray);display:flex;border-bottom:1px solid rgba(var(--white-rgb),.1)}.styles-module_Tab__2mqbl{cursor:pointer;font-size:13px;margin-top:12px;position:relative;top:1px;height:48px;display:flex;align-items:center;padding-right:10px;padding-left:10px;border-bottom:2px solid transparent}.styles-module_Tab__2mqbl svg{width:18px;height:18px;margin:0 5px 0 0}.styles-module_ActiveTab__3ZPc_{color:var(--white);border-bottom:2px solid var(--color-primary)}.styles-module_ActiveTab__3ZPc_ svg{fill:var(--color-primary)}";
var styles = {"Tabs":"styles-module_Tabs__2nklQ","Tab":"styles-module_Tab__2mqbl","ActiveTab":"styles-module_ActiveTab__3ZPc_"};
styleInject(css_248z,{"insertAt":"top"});

var Tabs = function (_a) {
    var children = _a.children;
    return (React.createElement("div", { className: styles.Tabs }, children));
};
var Tab = function (_a) {
    var active = _a.active, children = _a.children, dataCy = _a.dataCy, onClick = _a.onClick;
    return (React.createElement("div", { onClick: onClick, className: merge(styles.Tab, active && styles.ActiveTab), "data-cy": dataCy }, children));
};

export { Tab, Tabs };
